import { ReactElement } from 'react'
import { StaticImageData } from 'next/image'
import { LINKS } from 'routes/constants'
import { isBreadcrumb } from 'routes/components/Shared'

export function getSolutionsBreadcrumbs(title: string) {
  return [
    {
      href: LINKS.SOLUTIONS.HEAD,
      name: 'Solutions',
    },
    { name: title },
  ].filter(isBreadcrumb)
}

export type PageType = {
  title: string
  href: string
  tag?: string
  imageSrc: string
  srcSet?: string
  description: ReactElement | string
  large?: boolean
}

export type ConnectorsStatsType = {
  dataCollectionsCount: number
  operationsCount: number
  eventsCount: number
  prebuildConnectors: number
}

export type SolutionsHeroType = {
  title: string
  subtitle: string
  subtitleAdditional?: string
  imageWidth: string
  imageHeight: string
  mobile1x: StaticImageData
  mobile2x: StaticImageData
  desktop1x: StaticImageData
  desktop2x: StaticImageData
  showAsRow?: boolean
}
